export default "__VITE_ASSET__BXPUzNDX__"